import axios from 'axios';

export const get = () => axios.post('/api/users');
